import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

/** Confirmation de refus d'une inscription pro, avec motif facultatif (transmis au pro par e-mail). */
@Component({
  selector: 'app-pro-account-reject-dialog',
  standalone: true,
  imports: [FormsModule, MatDialogModule],
  template: `
    <div class="reject-dialog">
      <div class="fs-20 fw-7 mb-px-8">Refuser cette inscription ?</div>
      <div class="fs-14 mb-px-16">
        L'inscription de <b>{{ data.name }}</b> ({{ data.email }}) sera supprimée et le professionnel recevra un e-mail.
        Il pourra refaire une demande s'il le souhaite.
      </div>
      <label class="fs-13 fw-6" for="reject-reason">Motif (facultatif, transmis au professionnel)</label>
      <textarea id="reject-reason" class="form-control mt-px-4" rows="3" maxlength="500"
                [(ngModel)]="reason" placeholder="Ex. : numéro RPPS introuvable, profil incomplet…"></textarea>
      <div class="fs-11 text-neutral-dark-grey text-end">{{ reason.length }}/500</div>
      <div class="d-flex justify-content-end gap-2 mt-px-16 flex-wrap">
        <button type="button" class="btn btn-outline-secondary" (click)="close(false)">Annuler</button>
        <button type="button" class="btn btn-danger" (click)="close(true)">Refuser l'inscription</button>
      </div>
    </div>
  `,
  styles: [`.reject-dialog { padding: 24px; }`],
})
export class ProAccountRejectDialogComponent {
  reason = '';

  constructor(private ref: MatDialogRef<ProAccountRejectDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { name: string; email: string }) {
  }

  close(confirm: boolean): void {
    this.ref.close({ confirm, reason: this.reason.trim() || undefined });
  }
}
